var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1611_186)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.3553,
    cy: 25.9808,
    r: 8.98026,
    fill: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4321 61.6412C30.1487 60.6428 31.6337 60.6428 32.3503 61.6412L50.7415 87.2632C51.5944 88.4515 50.7451 90.1066 49.2824 90.1066H12.5C11.0373 90.1066 10.188 88.4515 11.0409 87.2632L29.4321 61.6412Z",
    fill: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9226 45.3712C65.6393 44.3744 67.1226 44.3744 67.8392 45.3712L97.9554 87.2622C98.8096 88.4504 97.9605 90.1067 96.4971 90.1067H36.2647C34.8013 90.1067 33.9522 88.4504 34.8064 87.2622L64.9226 45.3712Z",
    fill: "#DBDCDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1611_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySquare);
export default __webpack_public_path__ + "static/media/emptySquare.6dd3b92aaaac36de40b2518dd931f037.svg";
export { ForwardRef as ReactComponent };